import { Component, forwardRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WidgetValidator } from '@pt/pt-models';
import { ValidatorGenerator } from '../../utils';

@Component({
  selector: 'pt-input-text-area',
  templateUrl: './input-text-area.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputTextAreaComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputTextAreaComponent),
      multi: true
    }
  ]
})
export class InputTextAreaComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {

  @Input() inputId: string;
  @Input() validators: WidgetValidator[];
  @Input() label: string;
  @Input() fontWeightBold: boolean;
  @Input() placeholder: string;
  @Input() help: string;
  @Input() marginBottom = '1rem';
  @Input() error: string;// Da implementare
  @Input() minRow: number;
  @Input() maxLength: number;

  public formGroup: FormGroup;
  isChanged = false;
  required: boolean;
  public internalInputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;
  private currentValue?: string;

  ngOnChanges(): void {
    this.setFormGroup();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.internalInputId = 'ptWInputText_' + this.inputId;
  }

  writeValue(obj: any): void {
    this.currentValue = obj;
    this.formGroup.controls.value.setValue(obj, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable({ emitEvent: false });
    } else {
      this.formGroup.controls.value.enable({ emitEvent: false });
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    this.destroy$.next(true);
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.required = validator?.includes(Validators.required);

    this.formGroup = new FormGroup({
      value: new FormControl(this.currentValue, validator)
    });

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.currentValue = t.value;
      this.isChanged = t?.value !== null;
      if (this.onChanged) {
        // il bk preferisce null a testo vuoto '' questo è il motivo per cui ho modificato questa parte
        if (t && !!t.value && t.value.length > 0) {
          this.onChanged(t.value)
        } else {
          this.onChanged(null);
        }
        // this.onChanged(t ? t.value : t);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

}
